<template>
  <div
    :style="{ backgroundColor: bgColor }"
    :class="dayMode ? 'day-bg-wrap' : 'night-bg-wrap'"
    class="bg-cover">

    <!-- Use custom css to transition bg's -->
    <!-- DON'T use v-show because it uses display property which messes up gsap -->
    <day-bg class="bg-svg day-bg"/>
    <night-bg class="bg-svg night-bg"/>

    <div>
      <clouds/>
      <stars/>
      <sun/>
      <moon/>
    </div>
    <flowers/>
  </div>
</template>

<script>
import Clouds from './Clouds.vue'
import Sun from './Sun.vue'
import Moon from './Moon.vue'
import Stars from './Stars.vue'
import Flowers from './Flowers.vue'
import DayBg from './DayBg.vue'
import NightBg from './NightBg.vue'
import { mapState } from 'vuex'
import { TimelineMax, Power3, Power4, Power1, Linear } from 'gsap/TweenMax'
import { tlNight, tlDay, tlBg } from '@/mixins/timelines'

export default {
  name: 'DayNightBg',
  components: {
    Clouds,
    Sun,
    Moon,
    Stars,
    Flowers,
    DayBg,
    NightBg
  },

  mixins: [
    tlNight,
    tlDay,
    tlBg
  ],

  data () {
    return {
      tl: new TimelineMax()
    }
  },

  computed: {
    bgColor () {
      return this.dayMode ? '#C4F5EA' : '#143254'
    },

    ...mapState(['dayMode', 'preload'])
  },

  watch: {
    dayMode (newVal) {
      if (newVal) {
        this.tl.kill()
        this.tl.play('toDay')
      } else {
        this.tl.kill()
        this.tl.play('toNight')
      }
    }
  },

  mounted () {
    this.tl
      .set('.sun, .moon', { transformOrigin: '-30% 120%' })
      .set('.sun', { rotation: 0 })
      .set('.moon', { rotation: 180 })
      .set('.moon-img', { rotation: -180 })
      .set('.clouds-wrap', { xPercent: 0, yPercent: 0, opacity: 1 })
      .set('.stars', { xPercent: 10, yPercent: 15, opacity: 0 })
      .addPause('initDay')
      .add('toNight')
      .to('.ring', 0.5, { scale: 1, transformOrigin: '50% 50%', ease: Linear.easeNone })
      .to('.sun', 3.7, { rotation: -180, ease: Power1.easeInOut }, 'toNight+=0.5')
      .to('.moon, .moon-img', 3.7, { rotation: 0, ease: Power4.easeOut }, 'toNight+=0.9')
      .to('.stars', 2.5, { xPercent: 0, yPercent: 0, opacity: 1, ease: Power3.easeOut }, '-=2.7')
      .to('.clouds-wrap', 1.2, { xPercent: -15, yPercent: 15, opacity: 0, ease: Power1.easeIn }, 'toNight+=0.7')
      .add(() => {
        this.tlDay.kill()
      }, 'toNight+=0.7')
      .add(() => {
        this.tlNight.play()
      }, 'toNight+=0.7')
      .set('.sun', { rotation: 180 })
      .set('.moon, .moon-img', { rotation: 0 })
      .set('.clouds-wrap', { xPercent: 10, yPercent: 20, opacity: 0 })
      .set('.stars', { xPercent: 0, yPercent: 0, opacity: 1 })
      .addPause('initNight')
      .add('toDay')
      .to('.moon', 3.7, { rotation: -190, ease: Power1.easeInOut }, 'toDay')
      .to('.moon-img', 3.7, { rotation: 180, ease: Power1.easeInOut }, 'toDay')
      .to('.sun', 3.7, { rotation: 0, ease: Power4.easeOut }, 'toDay+=0.4')
      .to('.clouds-wrap', 2, { xPercent: 0, yPercent: 0, opacity: 1, ease: Power3.easeOut }, '-=2.5')
      .to('.stars', 1.2, { xPercent: -10, yPercent: 15, opacity: 0, ease: Power3.easeIn }, 'toDay')
      .to('.ring', 1.5, { scale: 1.1, transformOrigin: '50% 50%', repeat: -1, yoyo: true, ease: Linear.easeNone })
      .add(() => {
        this.tlDay.play()
      }, 'toDay+=0.4')
      .add(() => {
        this.tlNight.kill()
      }, 'toDay+=0.4')

    if (this.dayMode) {
      this.tlDay.play()
      this.tlNight.kill()
      this.tl.seek('initDay')
    } else {
      this.tlNight.play()
      this.tlDay.kill()
      this.tl.seek('initNight')
      this.tl.pause('toDay')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bg-cover {
    background-size: cover;
    min-height: 100vh;
    background-position: center;
    width: 100vw;
    overflow: hidden;
    position: absolute;
    transition: background-color 3.7s;
  }

  .bg-svg {
    /* object-fit: contain; */
    /* object-position: center bottom; */
    width: 100%;
    height: auto;
    position: absolute;
    bottom: 0;
    z-index: 1;
  }

  .night-bg-wrap .day-bg {
    transition: opacity 0.3s linear 3s;
    opacity: 0;
  }

  .day-bg-wrap .day-bg {
    transition: opacity 0.3s linear 0.4s;
    opacity: 1;
  }

  .day-bg-wrap .night-bg {
    opacity: 0;
  }

  .night-bg {
    transition: opacity 3.2s ease-out 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Background/DayNightBg.vue